import * as React from 'react';
import { AppContext } from '../../Context/app-state';
import { TColors } from '../../Data/data';
import './Filter-Color.css';

export default function FilterColor() {
  const { filters, setFilters } = React.useContext(AppContext);
  const { white, yellow, red, blue, green } = filters.color;

  const handleColorChange = (event: React.MouseEvent<HTMLElement>) => {
    const checkedColor = (event.target as Element).id as TColors;
    setFilters({
      ...filters,
      color: { ...filters.color, [checkedColor]: !filters.color[checkedColor] },
    });
  };
  return (
    <div className="filter-color" onClick={handleColorChange}>
      Цвет:
      <div id="white" className={`shape-ball ${white ? 'active' : ''}`} />
      <div id="yellow" className={`shape-bell ${yellow ? 'active' : ''}`} />
      <div id="red" className={`shape-bell ${red ? 'active' : ''}`} />
      <div id="blue" className={`shape-snowflake ${blue ? 'active' : ''}`} />
      <div id="green" className={`shape-toy ${green ? 'active' : ''}`} />
    </div>
  );
}
